// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';

import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import ScrollToTopButton from './components/ScrollToTopButton/ScrollToTopButton';
import ResetScroll from './components/ResetScroll/ResetScroll'; // Import here

import Homepage from './Homepage';
import InnovationStory from './components/Innovationstory/Innovationstory';
import ResourcesPage from './components/ResourcesPage/ResourcesPage';

function App() {
  return (
    <Router>
      <div className="sabiote-app">
        <Header />

        <ResetScroll />  {/* Add this */}

        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="/innovation" element={<InnovationStory />} />
          <Route path="/resources" element={<ResourcesPage />} />
        </Routes>

        <ScrollToTopButton />
        <Footer />
      </div>
    </Router>
  );
}

export default App;
